import { z } from 'zod'

import { TransferListItem } from 'components/Form/TransferList'
import { PageForGeneralForm } from '../hooks/useGetPage'
import { isRefreshControlledByYb } from '../utils'
import { commonSchema } from './commonSchema'

export const editSchema = z
  .object({
    id: z.string(),
  })
  .extend(commonSchema.shape)

export type EditSchema = z.infer<typeof editSchema>

export const editSchemaDefault = (page: PageForGeneralForm): EditSchema => {
  const {
    adUnits,
    customVariableName,
    customVariableTriggerEnabled,
    customVariableValue,
    domain: { id: domainId, overriddenByYieldbird, pubAdsServiceRefresh },
    id,
    matchType,
    name,
    onlySendAdRequestsForAssignedAdUnits,
    path,
    pathTriggerEnabled,
  } = page

  const refreshControlledByYb: boolean = isRefreshControlledByYb({
    overriddenByYieldbird,
    pubAdsServiceRefresh,
  })

  return {
    adUnitIds: {
      left: [],
      right: adUnits.map((adUnit: TransferListItem): TransferListItem['value'] => adUnit.value),
    },
    customVariableName: customVariableName ?? '',
    customVariableTriggerEnabled,
    customVariableValue: customVariableValue ?? '',
    domainId: domainId,
    id,
    matchType: matchType ?? 'include',
    name,
    onlySendAdRequestsForAssignedAdUnits: refreshControlledByYb
      ? onlySendAdRequestsForAssignedAdUnits
      : false,
    path: path ?? '',
    pathTriggerEnabled,
  }
}
